import { useConfig } from 'shared/config/ConfigContext';
import emptyState from '@/static/icons/EmptyState.svg';

export interface EmptyWarningProps {
    id: string;
    resetFilters: () => void;
    triggerFetch: (apiUrl: string) => void;
}

export const EmptyWarning = ({ id, resetFilters, triggerFetch }: EmptyWarningProps) => {
    const { apiUrl } = useConfig();
    return (
        <div className="u-text-center u-mt32" data-testid={`emptyWarning-${id}`}>
            <p className="u-t2 u-mb16">Vi fant ingen reiser på søket ditt</p>
            <p>Hvis du endrer på kriteriene kan vi finne en annen reise til deg.</p>
            <button
                data-testid={`emptyWarningButton-${id}`}
                type="button"
                aria-label="Nullstill søk"
                className="button button--default u-mv32"
                onClick={(): void => {
                    resetFilters();
                    triggerFetch(apiUrl);
                }}>
                Nullstill søket
            </button>
            <div>
                <img
                    src={emptyState.src}
                    height={emptyState.height}
                    width={emptyState.width}
                    loading={'lazy'}
                    alt="Katt som tar på en badeball"
                    className="img-format__img u-size1of2"
                />
            </div>
        </div>
    );
};
